<template>
  <div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Domain</th>
        <th>Time</th>
        <th>Expires</th>
        <th>Price</th>
        <th>TF</th>
        <th>CF</th>
        <th>Links</th>
        <th>Domains</th>
        <th>IPs</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(order, i) in orders" :key="i">
        <td>{{ order.domain.domain }}</td>
        <td>{{ $moment(order.time.date).format('DD.MM.YYYY HH:mm') }}</td>
        <td>{{ $moment(order.domain.date).format('DD.MM.') }}</td>
        <td>{{ order.price }}</td>
        <td>{{ order.domain.stats.tf }}</td>
        <td>{{ order.domain.stats.cf }}</td>
        <td>{{ order.domain.stats.links }}</td>
        <td>{{ order.domain.stats.domains }}</td>
        <td>{{ order.domain.stats.ips }}</td>
        <td>ORDERED</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      orders: []
    }
  },
  mounted () {
    this.loadOrders()
  },
  methods: {
    loadOrders () {
      axios.get('/domains/orders')
        .then(r => {
          this.orders = r.data.data
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Domains/OrdersTab.vue